import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import styles from './InfoList.module.sass'

const InfoList = ({ items, orientation = 'horizontal', className }) => {
	return (
		<VStack gap='xsmall' className={`${styles['root']} ${className || ''}`}>
			{items.map((item, index) => {
				return (
					<div key={index}>
						{item.icon ? (
							<HStack
								className={
									styles[
										`${
											!item.text?.length ? '--center' : ''
										}`
									]
								}
							>
								<Icon
									className={styles['status-icon']}
									width='20px'
									height='20px'
									name={item.icon}
								/>
								<VStack className={styles['content']}>
									<h5 key={index}>{item.title}</h5>
									<small>{item.text}</small>
								</VStack>
							</HStack>
						) : (
							<HStack
								className={styles['without-icon']}
								justify='space-between'
								gap='xsmall'
							>
								<div
									className={`${
										orientation === 'vertical'
											? styles['--vertical-details']
											: ''
									}`}
								>
									<h5 key={index}>{item.title}</h5>
									<small>{item.text}</small>
								</div>
								{item.quantity ? (
									<small className={styles['quantity']}>
										{item.quantity}
									</small>
								) : null}
							</HStack>
						)}
					</div>
				)
			})}
		</VStack>
	)
}

export default InfoList
